import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";
import logoimage from "./assets/final-logo.png"; // Corrected import path
import StickyNavbar from './StickyNavbar'; // Import the StickyNavbar component

const Navbar = () => {
    const [showMenu, setShowMenu] = useState(false);
    const [japaneseTime, setJapaneseTime] = useState("");
    const navbarRef = useRef(null); // Ref for the navbar

    // Update Japanese time every second
    useEffect(() => {
        const updateTime = () => {
            const now = new Date();
            const options = { timeZone: "Asia/Tokyo", hour: "2-digit", minute: "2-digit", second: "2-digit" };
            setJapaneseTime(new Intl.DateTimeFormat("ja-JP", options).format(now));
        };

        const intervalId = setInterval(updateTime, 1000);
        updateTime(); // Call immediately to avoid delay
        return () => clearInterval(intervalId); // Cleanup interval on component unmount
    }, []);

    // Close navbar when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (navbarRef.current && !navbarRef.current.contains(event.target)) {
                setShowMenu(false); // Close the navbar
            }
        };

        // Add event listener
        document.addEventListener("mousedown", handleClickOutside);

        // Cleanup event listener
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div>
            {/* Top Bar */}
            <StickyNavbar />
            <div className="topbar">
                <span>Japan Time: {japaneseTime}</span>
                <span><NavLink to="#">Support</NavLink></span>
                <span><NavLink to="/admin-panel">Login</NavLink></span>
            </div>

            {/* Navbar */}
          <div className="container-fluid">
              <nav className="navbar" ref={navbarRef}>
                <div className="logo">
                    <NavLink to="/">
                        <img src={logoimage} alt="Mitradingjp" className="logo-image" />
                        <p><b>M.I TRADING CO LTD - JAPAN </b> <br /> VEHICLE EXPORTING COMPANY</p>
                    </NavLink>
                </div>

                {/* Toggle Button */}
                <div className="toggle">
                    <button className="toggle-button" onClick={() => setShowMenu(!showMenu)}>
                        ☰
                    </button>
                </div>

                <ul className={`nav-items ${showMenu ? "show" : ""}`}>
                    <li className="dropdown">
                        <NavLink to="/" className={({ isActive }) => (isActive ? "nav-item active" : "nav-item")}>
                            Home
                        </NavLink>
                    </li>
                    <li className="dropdown">
                        <NavLink to="/search-cars" className={({ isActive }) => (isActive ? "nav-item active" : "nav-item")}>
                            Search Car
                        </NavLink>
                    </li>
                    <li className="dropdown">
                        <NavLink to="/banking-details" className={({ isActive }) => (isActive ? "nav-item active" : "nav-item")}>
                            Banking Details
                        </NavLink>
                    </li>
                    <li className="dropdown">
                        <NavLink to="#" className={({ isActive }) => (isActive ? "nav-item active" : "nav-item")}>
                            Services
                        </NavLink>
                        <ul className="dropdown-menu">
                            <li><NavLink to="/mijapan-auction">MI Japan Auction</NavLink></li>
                            <li><NavLink to="/chassis-check">Chassis Check</NavLink></li>
                            <li><NavLink to="/shipping">Shipping Schedule</NavLink></li>
                        </ul>
                    </li>
                    <li className="dropdown">
                        <NavLink to="#" className={({ isActive }) => (isActive ? "nav-item active" : "nav-item")}>
                            About Us
                        </NavLink>
                        <ul className="dropdown-menu">
                            <li><NavLink to="/company-profile">Company Profile</NavLink></li>
                            <li><NavLink to="/how-to-buy">How To Buy</NavLink></li>
                            <li><NavLink to="/customer-reviews">Customer Reviews</NavLink></li>
                            <li><NavLink to="/terms-condition">Terms/Condition</NavLink></li>
                            <li><NavLink to="/privacy-policy">Privacy Policy</NavLink></li>
                            <li><NavLink to="/faq-page">FAQ</NavLink></li>
                        </ul>
                    </li>
                </ul>
            </nav>
          </div>
        </div>
    );
};

export default Navbar;